import React from 'react';
import SectionHeading from './SectionHeading';
import ExpandableList  from './ExpandableList';

export default function Experience({ data }) {
  const { sectionHeading, allExperience } = data;

  return (
    <section className="section" id='achievments'>
      <div className="container">
        <SectionHeading
          miniTitle={sectionHeading.miniTitle}
          title={sectionHeading.title}
        />
        <ExpandableList listItems={allExperience} />
      </div>
    </section>
  );
}
